import {
  TableCell,
  TableRow,
  Collapse,
  Button,
  MenuItem,
  TextField,
  Grid,
} from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import moment from "moment";
import PropTypes from "prop-types";
import React from "react";
import DoneIcon from "@material-ui/icons/Done";
import { translate } from "react-i18next";
import { connect } from "react-redux";

import Loading from "../../loading";
import Snackbar from "../../snackbar";
import EditNote from "./editNote";
import { styles } from "./styles";
import { _parsePhoneNumber } from "../../../partials/validateNumber";
import { getNameBranch } from "../../../utils/setting";
import Header from "../../../partials/header";
import TableFormat from "../../../partials/TableFormat";
import PriceFormat from "../../../partials/priceFormat";
import FilterList from "../../../partials/filterList";

const headCells = [
  {
    key: "orderCode",
    numeric: false,
    disablePadding: false,
    label: "orders_tablehead_order_code",
  },
  {
    key: "branchName",
    numeric: false,
    disablePadding: false,
    label: "orders_tablehead_branch",
  },
  {
    key: "customerName",
    numeric: false,
    disablePadding: false,
    label: "orders_tablehead_customer",
  },
  {
    key: "totalPrice",
    numeric: false,
    disablePadding: false,
    label: "orders_tablehead_price",
  },
  {
    key: "status",
    numeric: false,
    disablePadding: false,
    label: "orders_tablehead_status",
  },
  {
    key: "statusPayment",
    numeric: false,
    disablePadding: false,
    label: "orders_tablehead_finish_payment",
  },
];
const listStatus = [
  {
    value: "new",
    label: "new",
    color: "rgb(45, 148, 178)",
  },
  {
    value: "processing",
    label: "processing",
    color: "rgb(225, 210, 36)",
  },
  {
    value: "cancel",
    label: "cancel",
    color: "rgb(208, 53, 53)",
  },
  {
    value: "done",
    label: "done",
    color: "rgb(130, 193, 77)",
  },
  {
    value: "abort",
    label: "abort",
    color: "rgb(208, 53, 53)",
  },
];
class Orders extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      arrange_date: {
        filter_by: "createdAt",
        from: new Date(new Date().setMonth(new Date().getMonth() - 1)).setHours(
          0,
          0,
          0,
          0
        ), // mặc định là từ 1 tháng trước ngày hiện tại
        to: new Date().setHours(23, 59, 59, 999), // nếu mặc định là '' => api sẽ bỏ qua không kiểm tra thời gian khi get list
      },
      status: -1,
      order: "desc",
      orderBy: "createdAt",
      selected: [],
      message: "",
      id: 1,
      collapse: [],
      dialog: {
        title: "",
        content: "",
        agree: "",
        action: "",
      },
      listFilter: {
        status: ""
      }
    };
    this.handleSubmitDelete = this.handleSubmitDelete.bind(this);
    this.handleFilterDate = this.handleFilterDate.bind(this);
  }
  handleChangeBranch = async (value) => {
    this.props.orderDispatch.changeSelectedBranch(value);
    this.getListOrdersForBranch({
      branchCode: value,
      limit: this.mTable.state.rowsPerPage,
      page: this.mTable.state.page,
    });
  };
  handleChangeStatus = (event) => {
    let name = event.target.name;
    let value = event.target.value;
    this.setState({ [name]: value });
  };
  checkListFilter = () => {
    let { status, listFilter } = this.state;
    listFilter["status"] = listStatus.find(item => item.value === status);
    listFilter["status"] = listFilter["status"] ? listFilter["status"].label : "";
    this.setState({ listFilter })
  }
  getListOrdersForBranch = async (payload) => {
    this.handleOpenCollapes(-1);
    let { t } = this.props;
    let { arrange_date, status } = this.state;
    let filter_exact = [];
    if (arrange_date.from && arrange_date.to)
      filter_exact.push({ arrange_date: arrange_date });
    if (status !== -1) filter_exact.push({ status: status });
    this.loading.startLoading();
    let check = await this.props.orderDispatch.getListOrdersForBranch({
      filter_exact: filter_exact,
      ...payload,
    });
    this.loading.stopLoading();
    this.checkListFilter();
    if (check.code !== 1) {
      if (check.code === 0 && check.error === 1174)
        this.mSnackbar.handleClick(
          t(
            "you_can_not_view_the_list_of_this_branch_because_you_do_not_have_permission_to_manage_this_branch"
          ),
          "error"
        );
      else this.mSnackbar.handleClick(check.message, "error");
    }
  };
  showFilter = (event) => {
    this.FilterList.toggleDrawer(true, event);
  };
  clearFilter = () => {
    let _this = this;
    this.setState(
      {
        status: -1,
        arrange_date: {},
        listFilter: {
          status: ""
        }
      },
      function () {
        let { page, rowsPerPage } = this.mTable.state;
        let { search } = _this.state;
        let filter_exact = [];
        _this.getListOrdersForBranch({
          page: page,
          limit: rowsPerPage,
          filter_exact: filter_exact,
          search: search,
        });
      }
    );
  };
  async handleSubmitDelete(selected = []) {
    let { t } = this.props;
    if (selected && selected.length) {
      let check = await this.props.orderDispatch.deleteOrders(selected);
      if (check.code === 1) {
        this.mSnackbar.handleClick(t("orders_delete_orders_successfully"));
        return true;
      } else {
        this.mSnackbar.handleClick(t("orders_delete_orders_unsuccessfully"));
        return false;
      }
    } else {
      this.mSnackbar.handleClick(t("pls_select_item"));
      return false;
    }
  }
  changeFormat(datetime) {
    return moment(datetime).format("DD/MM/YYYY hh:mm:ss A");
  }
  handleOpenCollapes = (id) => {
    const { listOrders = [] } = this.props;
    const collapse = this.state.collapse;
    for (let i = 0; i <= listOrders.length; i++) {
      if (i === id) {
        collapse[i] = !collapse[i];
      } else collapse[i] = false;
    }
    this.setState(collapse);
  };
  handleFilterDate(from, to) {
    const { arrange_date } = this.state;
    arrange_date.from = from ? new Date(from).setHours(0, 0, 0, 0) : null;
    arrange_date.to = to ? new Date(to).setHours(23, 59, 59, 999) : null;
    this.setState({ arrange_date: arrange_date }, function () {
      this.getListOrdersForBranch();
    });
  }
  renderStatus = (order) => {
    const { classes, t } = this.props;
    return listStatus.map((item, index) => {
      if (item.value === order.status)
        return (
          <Button
            key={index}
            classes={{
              root: classes.btnStatus,
            }}
            size="small"
            style={{ backgroundColor: item.color, color: "#fff" }}
          >
            {t(item.label)}
          </Button>
        );
    });
  };
  renderCollapse = (row, index) => {
    const { classes, listOrders } = this.props;
    const { collapse = [] } = this.state;
    return (
      <TableRow className={classes.tableRowHeight}>
        <TableCell
          colSpan={headCells.length + 1}
          padding={"none"}
          className={classes.tableCellInCollapes}
        >
          <Collapse in={collapse[index]} unmountOnExit>
            <EditNote
              item={index}
              data={listOrders[index]}
              handleSubmit={this.handleSubmit}
              {...this.props}
            />
          </Collapse>
        </TableCell>
      </TableRow>
    );
  };

  findBranchName(order) {
    let { listBranch, t } = this.props;
    // if (order) {
    // } else {
    //   return <div></div>;
    // }
    let { item } = order;
    return item.map((ele, i) => {
      let newArrBranch = [];
      if (ele.forAll === 1) {
        newArrBranch.push({ branchName: t("listOrder_apply_for_all_branches") });
      } else {
        if (Array.isArray(ele.arrBranch)) {
          ele.arrBranch.forEach((branchCode, i) => {
            let findBranchName = listBranch.find(
              (branch) => branch.branchCode === branchCode
            );
            if (findBranchName)
              newArrBranch.push({ branchName: findBranchName.branchName });
          });
        }
      }
      return newArrBranch.map((branch, index) => {
        return <div key={index}>{branch.branchName}</div>;
      });
    });
  }
  render() {
    const {
      classes,
      t,
      listOrders = [],
      total,
      infoServiceBranch,
      count,
    } = this.props;
    const { collapse, from, to, status, arrange_date, listFilter } = this.state;
    let ofBranch =
      infoServiceBranch && infoServiceBranch.branchName
        ? ` ${t("of")} ${infoServiceBranch.branchName}`
        : "";

    return (
      <React.Fragment>
        <Snackbar
          color="white"
          onRef={(snackbar) => (this.mSnackbar = snackbar)}
        />
        <Loading onRef={(id) => (this.loading = id)} />
        <Header
          session={t("sidebar_manage")}
          title={t("orders_order")}
          showFilterDate={true}
          handleFilterDate={this.handleFilterDate}
          titleToolipIconDateRange={t("orders_filter_by_time")}
          from={arrange_date.from} // mặc định là từ 1 tháng trước ngày hiện tại
          to={arrange_date.to}
        />
        <FilterList
          onRef={(id) => (this.FilterList = id)}
          clearFilter={this.clearFilter}
          getList={this.getListOrdersForBranch}
        >
          <Grid item xs={12} sm={12}>
            <TextField
              select
              label={t("booking_listbooking_status_booking")}
              placeholder={t("pls_select")}
              fullWidth
              className={classes.textField}
              value={status}
              onChange={this.handleChangeStatus}
              name="status"
              SelectProps={{
                MenuProps: {
                  className: classes.menu,
                },
              }}
              margin="normal"
              variant="outlined"
            >
              <MenuItem value={-1}>
                {t("booking_listbooking_show_all")}
              </MenuItem>
              {listStatus.map((item, index) => {
                return (
                  <MenuItem
                    key={`status-item-${index}`}
                    value={item.value}
                  >
                    {t(item.label)}
                  </MenuItem>
                )
              })}
            </TextField>
          </Grid>
        </FilterList>
        <TableFormat
          onRef={(ref) => (this.mTable = ref)}
          orderBy=""
          contentDialog={t("orders_do_you_want_to_delete_this_order_from_list")}
          onDelete={this.handleSubmitDelete}
          infoServiceBranch={infoServiceBranch}
          title={`${t("all")} ${t("orders_order")} ${ofBranch}`}
          showFilter={true}
          openFilter={(e) => this.showFilter(e)}
          listFilter={listFilter}
          showActionToolbar={false}
          placeholder={t("orders_search_by_code_customer_code_mobile")}
          headCells={headCells}
          totalCount={total}
          count={count}
          size={"medium"}
          isCollapse={true}
          collapse={collapse}
          renderCollapse={this.renderCollapse}
          handleOpenCollapes={this.handleOpenCollapes}
          getList={this.getListOrdersForBranch}
          showCheckBox={true}
          showFilterBranch={true}
          handleChangeBranch={this.handleChangeBranch}
          rows={listOrders.map((row, index) => {
            let validPhone = _parsePhoneNumber(
              row.countryCode,
              row.customerMobile
            ).format_internal;
            let updateAt = this.changeFormat(row.updatedAt);
            let moneyPaid = 0;
            if (Array.isArray(row.payment)) {
              row.payment.forEach((e) => {
                moneyPaid += e.moneyReceived - e.moneyChange;
              });
            }
            return {
              id: row.orderCode,
              orderCode: (
                <div className={classes.customColumn}>
                  <div>{row.orderCode}</div>
                  <div className={classes.updatedAtRow}>{updateAt}</div>
                </div>
              ),
              branchName: row.branchName
                ? row.branchName
                : this.findBranchName(row),
              customerName: (
                <div>
                  {row.customerName && <div>{row.customerName}</div>}
                  <div className={classes.updatedAtRow}>{validPhone}</div>
                </div>
              ),
              totalPrice: (
                <PriceFormat
                  value={`${row.totalPrice}`}
                  priceType={row.totalPrice < 0 ? "warning" : "regular"}
                />
              ),
              status: this.renderStatus(row),
              statusPayment:
                moneyPaid >= row.totalPrice ? <DoneIcon color="primary" /> : "",
            };
          })}
        />
      </React.Fragment>
    );
  }
}
Orders.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapState = (state) => ({
  infoServiceBranch: state.serviceBranch.infoServiceBranch,
  total: state.order.total,
  count: state.order.count,
  listOrders: state.order.listOrders,
  listBranch: state.serviceBranch.listBranch,
  selectedBranch: state.order.selectedBranch,
  currencyCode: state.setting.setting
    ? state.setting.setting.currencyCode
    : "VND",
});

const mapDispatch = (dispatch) => ({
  orderDispatch: dispatch.order,
});

export default connect(
  mapState,
  mapDispatch
)(translate("translations")(withStyles(styles)(Orders)));
